import { NavLink } from 'react-router-dom';
import './MedicoNav.css';

const items = [
  { to: '/medico/agenda', label: 'Agenda' },
  { to: '/medico/disponibilidad', label: 'Disponibilidad' },
  { to: '/medico/servicios', label: 'Servicios' },
  { to: '/notificaciones', label: 'Notificaciones' },
];

/** Sub-navegación del panel del médico. */
export default function MedicoNav() {
  return (
    <nav className="medico-nav" aria-label="Secciones de médico">
      {items.map((i) => (
        <NavLink
          key={i.to}
          to={i.to}
          className={({ isActive }) => `medico-nav-link ${isActive ? 'medico-nav-active' : ''}`}
        >
          {i.label}
        </NavLink>
      ))}
    </nav>
  );
}